import React from 'react';

const QuizBulkImportPanel = ({
  show,
  bulkImportData,
  setBulkImportData,
  loadBulkImportExample,
  handleBulkImport,
  bulkImportLoading,
  onClose,
  bulkImportResult,
  bulkImportError,
}) => {
  if (!show) return null;

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border mb-4 sm:mb-6">
      <h3 className="text-base sm:text-lg font-semibold mb-4">
        📥 Bulk Import Quiz Questions
      </h3>

      <div className="bg-blue-50 p-3 rounded-lg mb-4 border border-blue-200">
        <p className="text-sm font-medium text-blue-800 mb-2">📋 JSON Format Example:</p>
        <pre className="text-xs bg-white p-2 rounded overflow-auto border border-blue-100 max-h-48">
{`{
  "category": "Football",
  "questions": [
    {
      "question": "Who won FIFA 2022?",
      "options": ["France", "Argentina", "Brazil", "Spain"],
      "answer": "Argentina",
      "difficulty": "medium"
    },
    {
      "question": "Which club is called The Red Devils?",
      "options": ["Liverpool", "Chelsea", "Man United", "PSG"],
      "answer": "Man United",
      "difficulty": "easy"
    }
  ]
}`}
        </pre>
      </div>

      <textarea
        value={bulkImportData}
        onChange={(e) => setBulkImportData(e.target.value)}
        placeholder="Paste your JSON quiz questions here..."
        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 font-mono text-sm"
        rows={12}
      />

      <p className="text-xs text-gray-600 mt-2 mb-4">
        💡 Tip: Each question must have 4 options. The "answer" must match one of the options exactly. Optional: Add "difficulty" field (easy/medium/hard).
      </p>

      <div className="flex flex-col xs:flex-row gap-3">
        <button
          onClick={loadBulkImportExample}
          className="flex-1 bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg transition-colors font-medium text-sm"
        >
          📝 Load Example
        </button>

        <button
          onClick={handleBulkImport}
          disabled={bulkImportLoading || !bulkImportData.trim()}
          className="flex-1 bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg transition-colors font-medium text-sm"
        >
          {bulkImportLoading ? 'Importing...' : 'Import Questions'}
        </button>

        <button
          onClick={onClose}
          className="flex-1 bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg transition-colors font-medium text-sm"
        >
          Cancel
        </button>
      </div>

      {bulkImportResult && (
        <div className="mt-4 p-4 bg-green-100 border border-green-400 rounded-lg">
          <h4 className="text-green-800 font-bold mb-1 flex items-center gap-2">
            <span>✓ Success!</span>
          </h4>
          <p className="text-green-700 text-sm">{bulkImportResult.message}</p>
          <p className="text-green-700 text-sm font-medium mt-1">
            {bulkImportResult.count} questions imported successfully
          </p>
        </div>
      )}

      {bulkImportError && (
        <div className="mt-4 p-4 bg-red-100 border border-red-400 rounded-lg">
          <h4 className="text-red-800 font-bold mb-2 flex items-center gap-2">
            <span>✗ Error</span>
          </h4>
          <p className="text-red-700 text-sm mb-2">{bulkImportError.message}</p>
          {bulkImportError.errors && bulkImportError.errors.length > 0 && (
            <ul className="text-red-700 text-xs space-y-1 ml-4">
              {bulkImportError.errors.map((err, idx) => (
                <li key={idx} className="list-disc">
                  {err}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default QuizBulkImportPanel;